import React from "react";

import Slider from "react-slick";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

const Testimonials = () => {

  return (
    <section
      id="testimonial"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-12 "
          : " ")
      }
    >
      <div className="container">
        <p className="lead text-center mb-12">
          <b>На самому Коломийці Іванові нічого не оформлено! Все майно він оформляє на дружину Марію та родичів!</b>
        </p>
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-5">
            <b>Дані цього афериста:</b><br />
  Номер телефону: +380738888100<br />
  Номер автомобіля на якому він їздить ВН6666YL (Porsche Taycan)<br />
  інстаграм: @kolomiets3888<br />
  Facebook: Иван Коломиец<br />
  Телеграм: «General Infiniti»<br />
  Профіль на OLX на якому він продає запчастини та автомобілі: <a href="https://www.olx.ua/uk/list/user/WRICr/" target="_blank">https://www.olx.ua/uk/list/user/WRICr/</a><br />
  На дзвінки з ОЛХ відповідає його дружина Марія або він сам.<br />
  БУДЬТЕ ОБЕРЕЖНІ: З недавніх пір називає своє СТО General Infiniti<br />
  <br />

          </div>
          <div class="col-md-3">
            Фото шахрая Коломиец Иван  <br />
            <img className="img-fluid" src="images/image5.jpg" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-12">
<><br /><img classname="img-fluid" style={{ float: "left", margin: 5 }} src="images/e1.jpg" /><img classname="img-fluid" style={{ float: "left", margin: 5 }} src="images/e2.jpg" />
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ ІВАН ОЛЕКСАНДРОВИЧ</strong>
    <span style={{ fontWeight: 400 }}>
      , 24.04.1988 р.н., уродженець м. Потсдам ФРГ.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>УНЗР</strong>
    <span style={{ fontWeight: 400 }}>: 19880424-11970.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>: 3225613373.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Паспорт громадянина України </strong>
    <span style={{ fontWeight: 400 }}>
      (з ID-носієм) № 008676337, виданий 18.01.2023 року (5114).
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>Телефон: +380631092928.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>
      , станом на 2018 рік - м. Одеса, пр. Небесної Сотні (колишня назва -
      Маршала Жукова), буд. 30, кв. 28.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Освіта</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Державний професійно-технічний навчальний заклад «Одеське
      професійно-технічне училище машинобудування» (ЄДРПОУ: 2546246).
    </span>
  </p>
  <p>
    <strong> </strong>
    <strong>Трудова та підприємницька діяльність</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      З 20.06.2008 року зареєстрований, як ФОП, напрямки діяльності: технічне
      обслуговування та ремонт автомобілів (основний).
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Інше</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Перебуває на обліку в Біляївському РТЦК Одеської області.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Автотранспорт</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      «CHEVROLET BOLT», чорний, 2023 р.в., д.н. BH6507YA, поставлений на облік
      27.08.2024 року, за адресою: Одеська область, Біляївський район,
      с.Усатове, пров. Військовий, буд. 9а;
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      «TESLA MODEL S», білий, 2013 р.в., д.н. BH3243YA, поставлений на облік
      27.02.2026, за адресою: Одеська область, Біляївський район, с. Мирне,
      вул.Центральна, буд. 86;
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      «TESLA MODEL S», білий, 2012 р.в., д.н. BH9223YA, поставлений на облік
      25.12.2025, за адресою: Одеська область, Біляївський район, с. Мирне,
      вул.Центральна, буд.86.
    </span>
  </p>
  <p>&nbsp;</p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РОДИНА</strong>
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5 }} src="images/e3.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>друга дружина (з 18.11.2023)</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ (БУЛГАКОВА) МАРІЯ В’ЯЧЕСЛАВІВНА</strong>
    <span style={{ fontWeight: 400 }}>
      , 31.10.1996 р.н., м. Первомайськ Миколаївської області.&nbsp;
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>УНЗР</strong>
    <span style={{ fontWeight: 400 }}>: 19961031-05328.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>: 3536807164.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Паспорт громадянина України </strong>
    <span style={{ fontWeight: 400 }}>
      (з ID-носієм) № 010089998, виданий 29.12.2023 року (5115).
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Контактний телефон: +380739999100, +380930496906.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Адреса електронної пошти: mari.bulgakova959595@gmail.com.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>
      , станом на 2018 рік - Миколаївська область, м.Первомайськ, вул. Рози
      Люксембург, буд. 5, кв. 20.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Інші відомі адреси</strong>
    <span style={{ fontWeight: 400 }}>:&nbsp;</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      - м. Одеса, вул. Академіка Воробйова, буд. 1б, кв. 49 (зазначена при
      реєстрації ФОП);
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      - Одеська область, Овідіопольський район, смт. Таїрове, с. Лиманка, вул.
      Перлинна, буд. 2, кв. 110.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Трудова та підприємницька діяльність</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      З 17.04.2022 року зареєстрована як ФОП, заявлені напрямки підприємницької
      діяльності:{" "}
    </span>
    <span style={{ fontWeight: 400 }}>
      ремонт годинників і ювелірних виробів
    </span>
    <span style={{ fontWeight: 400 }}> (основний).&nbsp;</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Автотранспорт</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Власниця автомобіля «PORSCHE TAYCAN», чорного кольору, 2020 р.в., д.н.
      BH6666YL, поставлений на облік 19.10.2024 року.
    </span>
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 180 }} src="images/e4.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      перша дружина (шлюб з 15.10.2023 по 16.10.2023)
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ (ЛИСИЦЯ) АНАСТАСІЯ ЮРІЇВНА</strong>
    <span style={{ fontWeight: 400 }}>
      , 21.08.1988 р.н., уродженка м. Астрахань РФ.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>:</span>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>3237515809.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>
      , станом на 2018 рік - м. Одеса, вул. Паркова, буд. 43, кв.9.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Інші відомі адреси проживання</strong>
    <span style={{ fontWeight: 400 }}>:&nbsp;</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      м. Одеса, вул. Паркова, буд. 43, кв. 9;
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      м. Одеса, вул. Балківська, буд. 36, кв. 150;
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      м. Одеса, вул. Одеська, буд. 58, корпус 5, кв. 11.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 140 }} src="images/e4.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>донька від першого шлюбу</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ МАРІЯ ІВАНІВНА</strong>
    <span style={{ fontWeight: 400 }}>
      , 07.07.2015 р.н., уродженка м. Одеса.
    </span>
  </p>
  <p>
    <br />
    <br />
    <br />
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 140 }} src="images/e4.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>донька від першого шлюбу</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ ЄЛИЗАВЕТА ІВАНІВНА</strong>
    <span style={{ fontWeight: 400 }}>
      , 03.07.2020 р.н., уродженка м.Одеса.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
  </p>
  <p>&nbsp;</p><br /><br /><br />
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 140 }} src="images/e5.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>батько</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ ОЛЕКСАНДР БОРИСОВИЧ</strong>
    <span style={{ fontWeight: 400 }}>, 28.06.1961 р.н.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>, станом на 2018 рік -</span>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      м. Сімферополь, вул. Гагаріна, буд.36, кв. 54.
    </span>
  </p>
  <p>
    <br />
    <br />
    <br />
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5 }} src="images/e6.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>мати</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ ЛЮБОВ ІВАНІВНА</strong>
    <span style={{ fontWeight: 400 }}>, 18.09.1959 р.н.</span>
    <span style={{ fontWeight: 400 }}> </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>: 2181020623.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>Телефон: +380635308752.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>
      , станом на 2018 рік - м. Одеса, пр. Небесної Сотні (колишня назва - вул.
      Маршала Жукова), буд.30, кв. 28.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Інші відомі адреси проживання</strong>
    <span style={{ fontWeight: 400 }}>:&nbsp;</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      м. Сімферополь, вул. Гагаріна, буд. 30, кв. 28;
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>м. Одеса, пр. Гагаріна, буд. 19.</span>
  </p>
  <p>
    <br />
    <br />
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Трудова діяльність</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Свого часу - Залізнична лікарня, медсестра; «Одеський обласний
      спортивно-технічний клуб» (ЄДРПОУ: 22458875); ВЧ А2524 (ЄДРПОУ: 14321920).
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Автотранспорт</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Власниця автомобіля «TESLA MODEL S», синій, 2014 р.в., д.н. BH9227YA,
      поставлений на облік 25.12.2025 року.
    </span>
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 180 }} src="images/e5.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>брат</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ ОЛЕКСАНДР ОЛЕКСАНДРОВИЧ</strong>
    <span style={{ fontWeight: 400 }}>
      , 10.11.1984 р.н., уродженець м. Сімферополь АР Крим.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>: 3099516796.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Паспорт громадянина України</strong>
    <span style={{ fontWeight: 400 }}>
      {" "}
      cерії ОК № 021140, виданий 10.09.2016 року Київським РВ м. Одеси.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>Телефон: +380631496969.</span>
    <span style={{ fontWeight: 400 }}>&nbsp;</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Адреса електронної пошти: kolomiets.web@gmail.com.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>
      , станом на 2018 рік - м. Одеса, пр. Маршала Жукова, буд. 30, кв. 28.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса, зазначена при реєстрації ФОП</strong>
    <span style={{ fontWeight: 400, color: "red" }}>: м</span>
    <span style={{ fontWeight: 400, color: "red" }}>
      . Одеса, вул. Дмитріївська, буд.59, корпус 2, кв. 3.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Освіта</strong>
    <span style={{ fontWeight: 400 }}> - вища.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Трудова та підприємницька діяльність</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      З 20.09.2016 року зареєстрований, як ФОП, напрямки діяльності: рекламні
      агентства (основний); виробництво будівельних металевих конструкцій і
      частин конструкцій; інші спеціалізовані будівельні роботи, н.в.і.у.;
      комп'ютерне програмування; посередництво в розміщенні реклами в засобах
      масової інформації; ремонт і технічне обслуговування готових металевих
      виробів; інша допоміжна діяльність у сфері транспорту; оптова торгівля
      верстатами; оптова торгівля іншими машинами й устаткованням; оптова
      торгівля іншими офісними машинами й устаткованням; оптова торгівля
      офісними меблями.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 180 }} src="images/e4.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>дружина брата</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ (ПРОШЛЕЦОВА) ОКСАНА СЕРГІЇВНА</strong>
    <span style={{ fontWeight: 400 }}>, 20.04.1983р.н.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>: 3042506002.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Паспорт громадянина України</strong>
    <span style={{ fontWeight: 400 }}>
      {" "}
      серії ЕН № 882329, виданий 04.08.2012 року Антрацитівським МВ УДМС України
      в Луганській області.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>Телефон: +380634423742.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>
      , станом на 2018 рік - Луганська область, м. Антрацит, вул. Паркова, буд.
      25, кв. 49.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Інші відомі адреси проживання</strong>
    <span style={{ fontWeight: 400 }}>
      : м. Одеса, пр. Маршала Жукова, буд. 30, кв. 28.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Автотранспорт</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Власниця автомобіля «МЕRСЕDЕS-ВЕNZ S 320», сірого кольору, 1999р.в., д.н.
      BH4055TX, поставлений на облік 26.07.2024 року.
    </span>
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 180 }} src="images/e5.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>племінник</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ РОСТИСЛАВ ОЛЕКСАНДРОВИЧ</strong>
    <span style={{ fontWeight: 400 }}>, 15.12.2012 р.н.</span>
  </p>
  <p>
    <br />
    <br />
    <br />
    <br />
  </p><br />
  <p><img classname="img-fluid" style={{ float: "left", margin: 5 }} src="images/e7.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>брат (близнюк/двійнята)</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ БОРИС ОЛЕКСАНДРОВИЧ</strong>
    <span style={{ fontWeight: 400 }}>, 24.04.1988 р.н.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>: 3225613338.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Паспорт громадянина України</strong>
    <span style={{ fontWeight: 400 }}>
      {" "}
      серії СМ № 748630, виданий 26.04.2005 року Київським РВ ОМУ МВС України в
      Одеській області.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>Телефон: +380631499461.</span>
    <span style={{ fontWeight: 400 }}> </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>
      , станом на 2018 рік - м. Одеса, пр. Маршала Жукова, буд. 30, кв. 28.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса, зазначена при реєстрації ФОП</strong>
    <span style={{ fontWeight: 400 }}>
      : м. Одеса, вул. Михайлівська, буд. 8, корпус 5, кв. 91.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Трудова та підприємницька діяльність</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      З 05.07.2019 року зареєстрований, як ФОП, заявлені напрямки
      підприємницької діяльності: технічне обслуговування та ремонт
      автотранспортних засобів (основний); надання в оренду автомобілів і
      легкових автотранспортних засобів; надання в оренду й експлуатацію
      власного чи орендованого нерухомого майна.
    </span>
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5 }} src="images/e8.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>дружина брата</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ ІННА СЕРГІЇВНА</strong>
    <span style={{ fontWeight: 400 }}>, 08.02.1991 р.н.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>: 3327615507.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Паспорт громадянина України </strong>
    <span style={{ fontWeight: 400 }}>
      (з ID-носієм) № 000989541, виданий 21.09.2017 року (5141).
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>
      , станом на 2018 рік - Одеська область, Роздільнянський район, с. Надія,
      вул. Лісна, буд. 40.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Інші відомі адреси проживання</strong>
    <span style={{ fontWeight: 400 }}>:&nbsp;</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      - м. Одеса, вул. Михайлівська, буд. 8, корпус 5, кв. 91 (адреса, зазначена
      при реєстрації ФОП);
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      - м. Одеса, вул. Михайлівська, буд. 8/5, кв. 91.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Трудова та підприємницька діяльність</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      З 05.07.2019 року зареєстрована, як ФОП, заявлені напрямки підприємницької
      діяльності: надання послуг перукарнями та салонами краси (основний); інші
      види освіти, н.в.і.у.; роздрібна торгівля косметичними товарами та
      туалетними приналежностями в спеціалізованих магазинах 96.09 надання інших
      індивідуальних послуг, н.в.і.у.; інші види роздрібної торгівлі в
      неспеціалізованих магазинах; надання в оренду й експлуатацію власного чи
      орендованого нерухомого майна.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Автотранспорт</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Власник автомобіля «VOLKSWAGEN TIGUAN», чорного кольору, 2017р.в., д.н.
      ВН0018МР.
    </span>
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 180 }} src="images/e5.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>племінник</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КОЛОМІЄЦЬ ВЛАДИСЛАВ БОРИСОВИЧ</strong>
    <span style={{ fontWeight: 400 }}>, 27.02.2023 р.н.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>: 4498300073.</span>
  </p>
  <p>&nbsp;</p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
  </p>
  <p>&nbsp;</p><br />
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 180 }} src="images/e4.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>сестра другої дружини</span>
  </p>
  <p>
    <strong> </strong>
    <strong>БУЛГАКОВА НАТАЛІЯ В’ЯЧЕСЛАВІВІНА</strong>
    <span style={{ fontWeight: 400 }}>, 21.02.1990р.н.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>: 3292414966.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Паспорт громадянина України</strong>
    <span style={{ fontWeight: 400 }}>
      {" "}
      серії ЕР № 519919, виданий 24.10.2014 року&nbsp; Первомайським РВ УДМС в
      Миколаївській області.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Телефон: +380933869627, +380932635624
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>
      , станом на 2018 рік - Миколаївська область, м.Первомайськ, вул. Рози
      Люксембург, буд. 5, кв. 20.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Інші відомі адреси проживання</strong>
    <span style={{ fontWeight: 400 }}>
      : Миколаївська область, м. Первомайськ, вул. Урицького, буд. 133.&nbsp;
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Трудова та підприємницька діяльність</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      В період з 01.04.2010 по 11.10.2012 рік була зареєстрована, як ФОП
      (посередництво в торгівлі товарами широкого асортименту (основний)).
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 180 }} src="images/e5.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>чоловік сестри другої дружини</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КУЗЬМЕНКО&nbsp; ДЕНИС ВОЛОДИМИРОВИЧ</strong>
    <span style={{ fontWeight: 400 }}>, 09.11.1981р.н. </span>
    <strong> </strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>РНОКПП</strong>
    <span style={{ fontWeight: 400 }}>: 2989814174.</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Паспорт громадянина України</strong>
    <span style={{ fontWeight: 400 }}>
      {" "}
      серії ЕО № 716386, виданий 16.06.1999 року Первомайським МВ УМВС України в
      Миколаївській області.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Телефон: +380634497307, +380932635624.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Адреса реєстрації</strong>
    <span style={{ fontWeight: 400 }}>
      , станом на 2018 рік - Миколаївська область, м.Первомайськ, вул.
      Урицького, буд. 139.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Освіта</strong>
    <span style={{ fontWeight: 400 }}> - вища.</span>
  </p>
  <p>
    <strong> </strong>
    <strong>Трудова та підприємницька діяльність</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      З 19.03.2015 року зареєстрований, як ФОП, заявлені напрямки діяльності:
      технічне обслуговування та ремонт автотранспортних засобів (основний);
      роздрібна торгівля деталями та приладдям для автотранспортних засобів;
      ремонт комп'ютерів і периферійного устатковання; діяльність ресторанів,
      надання послуг мобільного харчування; інші види роздрібної торгівлі в
      неспеціалізованих магазинах.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      В період з 04.08.2011 по 21.07.2014 - ФОП (інші види роздрібної торгівлі в
      неспеціалізованих магазинах (основний)).
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      В період з 25.05.2006 по 19.12.2008 - ФОП (роздрібна торгівля з лотків та
      на ринках (основний)).
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>Автотранспорт</strong>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>
      Власник автомобіля «VOLKSWAGEN PASSAT», жовтого кольору, 2011р.в., д.н.
      KA4927PO, поставлений на облік 16.09.2025 року.
    </span>
  </p>
  <p><img classname="img-fluid" style={{ float: "left", margin: 5, width: 180 }} src="images/e4.jpg" />
    <span style={{ fontWeight: 400 }}> </span>
    <span style={{ fontWeight: 400 }}>племінниця другої дружини</span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
    <strong>КУЗЬМЕНКО&nbsp; ЯНА ДЕНИСІВНА</strong>
    <span style={{ fontWeight: 400 }}>
      , 31.01.2011 р.н., уродженка м. Первомайськ Миколаївської області.
    </span>
  </p>
  <p>
    <span style={{ fontWeight: 400 }}> </span>
  </p>
  <p>&nbsp;</p>
</>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
